import React, { useEffect, useState } from "react";
import Edit from "../../../assets/images/Edit.svg";
import Trash from "../../../assets/images/Trash.svg";
import Modal from "../../../components/Modal";
import EditBooking from "./EditBooking";
import CancelBooking from "./CancelBooking";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Spinner from "../../../components/Spinner";

const BookedTourCard = ({
  imageSrc,
  title,
  tourType,
  startFrom,
  tour_name,
  startAt,
  endAt,
  endTime,
  onChange,
  onCancel,
  setIsChangeModalOpen,
  setIsCancelModalOpen,
  closeModal,
  itemId,
  current_tour_id,
  date,
  attendanceId,
}) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const navigate = useNavigate();
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  const handleImageLoad = () => {
    setIsImageLoaded(true); // Set to true when the image fully loads
  };

  const handleOptionClick = (option, itemId) => {
    if (option === "Change") {
      navigate("update", {
        state: {
          date: date,
        },
      });
    } else if (option === "Cancel") {
      setIsCancelModalOpen({
        open: true,
        itemId,
        title,
        tourType,
        date,
        attendanceId,
      });
    }
  };
  const toggleDropdown = () => setIsDropdownOpen(!isDropdownOpen);
  const [currentName, setCurrentName] = useState();

  useEffect(() => {
    const obj = tour_name?.find((item) => {
      return item?.id == current_tour_id;
    });

    if (obj) {
      setCurrentName(obj?.name);
    } else {
    }
  }, [tour_name]); // This effect runs when responseData is updated

  return (
    <>
      {/* Hidden image to trigger onLoad event */}
      <img
        src={imageSrc}
        alt="Tour Map"
        className="leap-hidden" // Hide the image from view
        onLoad={handleImageLoad}
      />
      {isImageLoaded ? (
        <div
          className="card leap-bg-white leap-rounded-[8px] leap-w-fit"
          style={{ boxShadow: "0px 2px 48px 0px #0000000A" }}
        >
          {" "}
          <img
            src={imageSrc}
            alt="Tour Map"
            className="leap-p-3"
            loading="lazy"
            onLoad={handleImageLoad}
          />
          <div className="leap-flex leap-justify-between leap-px-3">
            <div className="leap-flex leap-gap-1">
              <span className="leap-text-xl leap-text-[#3B29AB] leap-font-bold leap-uppercase">
                ({title})
              </span>
              <span className="!leap-my-auto leap-text-xs leap-text-[#77679F] leap-font-bold leap-uppercase">
                {currentName}
              </span>
            </div>
            {/* Three dots menu with dropdown */}
            <div className="leap-relative">
              <button
                onClick={toggleDropdown}
                className="leap-text-2xl leap-font-bold leap-pr-3 leap-cursor-pointer"
              >
                &#x22EE;
              </button>
              {isDropdownOpen && (
                <div className="leap-absolute leap-right-0  leap-bg-white leap-border leap-rounded-[6px] leap-shadow-md leap-py-2">
                  <button
                    onClick={() => {
                      handleOptionClick("Change", itemId);
                    }}
                    className=" leap-flex leap-gap-2 leap-justify-center leap-uppercase  leap-w-full leap-text-left leap-px-8 leap-py-2 hover:leap-bg-[#E7F0FA]"
                  >
                    <img src={Edit} alt="" loading="lazy" />{" "}
                    <span className="leap-text-[#0A65CC] leap-text-sm leap-font-[600]">
                      Change
                    </span>
                  </button>

                  <button
                    onClick={() => handleOptionClick("Cancel", itemId)}
                    className="leap-flex leap-gap-2 leap-justify-center leap-uppercase  leap-w-full leap-text-left leap-px-8 leap-py-2 hover:leap-bg-[#E7F0FA]"
                  >
                    <img src={Trash} alt="" loading="lazy" />
                    <span className="leap-text-[#E05151] leap-text-sm leap-font-[600]">
                      Cancel
                    </span>
                  </button>
                </div>
              )}
            </div>
          </div>
          <div className="Date-place leap-flex leap-gap-6 leap-px-3 leap-mt-2 leap-mb-9">
            <div className="leap-flex leap-flex-col leap-gap-3">
              <div className="leap-flex leap-gap-1"></div>
              <div className="leap-flex leap-gap-1">
                <span className="leap-uppercase leap-text-sm leap-text-[#9499A1] leap-w-24">
                  START AT
                </span>
                <span className="leap-uppercase leap-font-semibold leap-text-sm leap-text-[#3D475C]">
                  {startAt}
                </span>
              </div>
            </div>

            <div className="leap-flex leap-flex-col leap-gap-3">
              <div className="leap-flex leap-gap-3"></div>
              <div className="leap-flex leap-gap-3">
                <span className="leap-uppercase leap-text-sm leap-text-[#9499A1] leap-w-16">
                  END AT
                </span>
                <span className="leap-uppercase leap-font-semibold leap-text-sm leap-text-[#3D475C]">
                  {endTime}
                </span>
              </div>
            </div>
          </div>{" "}
        </div> // Show loading placeholder while image is loading
      ) : (
        <div className="card leap-bg-white/20 leap-rounded-[8px] leap-min-w-[20rem] leap-min-h-[20rem]">
          <div className="card  leap-rounded-[8px] leap-min-w-[20rem] leap-min-h-[20rem] leap-flex leap-items-center leap-justify-center leap-scale-75">
            <Spinner />
          </div>
        </div>
      )}
    </>
  );
};

export default BookedTourCard;
